import { ref, toRaw } from 'vue'

export default function (tableRef: any, config: any, emits: any) {
  const { showSelection, rowKey, canRowClick } = config.value
  const multipleSelection = ref<any[]>([])

  const handleSelectionChange = (val: any[]) => {
    multipleSelection.value = val.map(e => e[rowKey])
    emits('selection-change', val.map(e => toRaw(e)))
  }

  const handleSortChange = (val: any) => {
    emits('sort-change', val)
  }

  const handleRowClick = (row: any) => {
    emits('row-click', row)
  }

  const clearSelection = () => {
    multipleSelection.value = []
    tableRef.value.clearSelection()
  }

  // 用于多选表格，切换全选和全不选
  const toggleAllSelection = () => {
    tableRef.value.toggleAllSelection()
  }
  // 勾选某行
  const toggleRowSelection = (row:any, selected:boolean) => {
    tableRef.value.toggleRowSelection(row, selected)
  }
  return {
    handleSelectionChange: showSelection ? handleSelectionChange : undefined,
    toggleRowSelection: showSelection ? toggleRowSelection : undefined,
    clearSelection: showSelection ? clearSelection : undefined,
    toggleAllSelection: showSelection ? toggleAllSelection : undefined,
    handleRowClick: canRowClick ? handleRowClick : undefined,
    handleSortChange: handleSortChange
  }
}
